import { render } from "./BrandConnect724.vue?vue&type=template&id=5187df6a"
import script from "./BrandConnect724.vue?vue&type=script&lang=ts"
export * from "./BrandConnect724.vue?vue&type=script&lang=ts"

import "./BrandConnect724.vue?vue&type=style&index=0&id=5187df6a&lang=scss"
script.render = render

export default script